import { useQuery } from '@tanstack/react-query';
import {
  fetchOnboardingBannerStatus,
  fetchOnboardingReassignCandidates,
  fetchOrganizationSettings,
} from '../api/accountsApi';

export const onboardingKeys = {
  settings: (orgId: string) => ['onboarding', 'settings', orgId] as const,
  bannerStatus: (orgId: string) => ['onboarding', 'banner-status', orgId] as const,
  reassignCandidates: (orgId: string) => ['onboarding', 'reassign-candidates', orgId] as const,
};

export function useOnboardingSettings(orgId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: onboardingKeys.settings(orgId ?? ''),
    queryFn: () => fetchOrganizationSettings(orgId!),
    enabled: Boolean(orgId) && enabled,
    staleTime: 30_000,
  });
}

export function useOnboardingBannerStatus(orgId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: onboardingKeys.bannerStatus(orgId ?? ''),
    queryFn: () => fetchOnboardingBannerStatus(orgId!),
    enabled: Boolean(orgId) && enabled,
    staleTime: 30_000,
  });
}

export function useOnboardingReassignCandidates(orgId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: onboardingKeys.reassignCandidates(orgId ?? ''),
    queryFn: () => fetchOnboardingReassignCandidates(orgId!),
    enabled: Boolean(orgId) && enabled,
    staleTime: 30_000,
  });
}

export function isOnboardingIncomplete(
  onboardingStatus: string | null | undefined,
): boolean {
  return onboardingStatus == null || onboardingStatus === 'incomplete';
}

export function isOnboardingCompleted(
  onboardingStatus: string | null | undefined,
): boolean {
  return onboardingStatus === 'completed';
}

/** Option C: onboarding wizard/banner only for new compliance_education orgs. */
export function isOnboardingEligible(
  onboardingEligible: boolean | null | undefined,
  appAccountType?: 'compliance_education' | 'legacy' | 'trial',
): boolean {
  if (onboardingEligible === true) {
    return true;
  }
  if (onboardingEligible === false) {
    return false;
  }
  // Pre-deploy API responses omit the field; gate on account type until backend is live.
  return appAccountType === 'compliance_education';
}
